import { differenceInCalendarMonths, parseISO } from 'date-fns'

export class PrazoEntregaSimulacao {
  constructor(
    private readonly dataSimulacao: string,
    private readonly dataPrevistaEntregaDoBloco: string,
  ) {}

  get prazoEntregaEmMeses() {
    return differenceInCalendarMonths(parseISO(this.dataPrevistaEntregaDoBloco), parseISO(this.dataSimulacao))
  }

  get isEmpreendimentoEntregue() {
    return this.dataSimulacao >= this.dataPrevistaEntregaDoBloco
  }
}
